import * as React from "react";
import "./Homepage.css";
import Typography from "@mui/material/Typography";
import Hero from "../Components/Hero";
import Footer from "../Components/Footer";
import Cards from "../Components/Cards";

// images
import Trailer    from "../Images/Trailer/trailer-on-pad-1.jpeg";
import TeamPhoto  from "../Images/testTeam1.png";
import SparrowImg from "../Images/Sparrow/engine-on-table.png";

export default function Homepage() {
  return (
    <>
      <Hero />

      {/* ---------- intro blurb ---------- */}
      <div className="InfoContainer">
        <div className="InfoWrapper">
          <div className="InfoRow1">
            <div className="Column1">
              <Typography sx={{ fontSize: 42, fontFamily: "Noto Sans", fontWeight: "bold", color: "#383838" }}>
                What is FRL?
              </Typography>

              <Typography sx={{ fontSize: 20, fontFamily: "Noto Sans", color: "#383838", mt: 1.5 }}>
              Florida Rocket Lab is the liquid propulsion team at the University of Florida. Successfully designing, building, and hotfiring Sparrow. A reliable, tested bi-propellant engine producing 550 lbf of thrust. We are now focused on developing the vehicle to mount it on. Transitioning from engine development to full system operation, we are engineering a complete lander for the Collegiate Propulsive Lander Competition, pushing the boundaries of student-led rocketry.
              </Typography>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- highlight cards ---------- */}
      <div className="HomepageContentBox">
        <div className="cards__container">
          {/* Trailer card opens modal index 1 in /projects */}
          <Cards
            
            prjNum="1"
            location="/projects"
            linkState={{ openIndex: 1 }}
            color="#ffffff"
            title="Trailer Mobile Testbed"
            img={Trailer}
            text="Our mobile test stand enabled Sparrow’s first static fire and will serve as ground systems for launching Hopper."
          />

          {/* Sparrow card opens modal index 0 in /projects */}
          <Cards
            prjNum="0"
            location="/projects"
            linkState={{ openIndex: 0 }}
            color="#ffffff"
            title="Sparrow Engine"
            img={SparrowImg}
            text="Sparrow is UF’s first student-built bi-propellant engine, producing 550 lbf with IPA/N₂O."
          />

          {/* Team card – no modal flag needed */}
          <Cards
            prjNum="NA"
            location="/ourteam"
            color="#ffffff"
            title="Testing Team"
            img={TeamPhoto}
            text="Our Testing Team follows strict industry-level procedures to run Sparrow hot-fires safely and reliably."
          />
        </div>
      </div>

      <Footer />
    </>
  );
}
